import { CustomButton } from '@Modules/core/components';
import CustomModal from '@Modules/core/components/modal/CustomModal';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import UsersProfileFormHandler from '../containers/formHandlers/UsersProfileFormHandle/UsersProfileFormHandler';

export default function UsersProfileFormModal() {
  const profileModalRef = React.useRef<any>(null);
  const confirmationModalRef = React.useRef<any>(null);
  const usersProfileFormHandlerRef = React.useRef<any>(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const openProfileModal = () => {
    const profileModal = profileModalRef?.current;
    if (profileModal) {
      profileModalRef.current.onOpen();
    }
  };

  const closeProfileModal = () => {
    const profileModal = profileModalRef?.current;
    if (profileModal) {
      profileModalRef.current.onClose();
    }
  };

  return (
    <>
      <CC.Box my="4">
        <CustomButton onClick={openProfileModal}>
          Ajouter un profil
        </CustomButton>
      </CC.Box>

      <CustomModal
        isLoading={isLoading}
        ref={profileModalRef}
        title="Ajout d'un nouveau profil"
        actionBtnText="Créer le profil"
        cancelBtnText="Annuler"
        actionBtnClick={() =>
          usersProfileFormHandlerRef?.current?.triggerSubmit()
        }
        cancelBtnClick={() => confirmationModalRef?.current.onOpen()}
        size="4xl"
        closeOnOverlayClick={false}
      >
        <CC.Box minH={'xs'}>
          <UsersProfileFormHandler
            setIsLoading={setIsLoading}
            closeModal={closeProfileModal}
            ref={usersProfileFormHandlerRef}
          />

          <CustomModal
            ref={confirmationModalRef}
            title="Confirmation"
            actionBtnText="Oui"
            cancelBtnText="Non"
            actionBtnClick={() => {
              confirmationModalRef?.current.onClose();
              profileModalRef?.current.onClose();
            }}
          >
            <p>Voulez vous vraiment annuler ?</p>
          </CustomModal>
        </CC.Box>
      </CustomModal>
    </>
  );
}
